export enum StoreType {
  CATERSYS,
  MENY,
  CITYCATERING,
  NEW_YEAR,
  GOURMIDDAG,
  GASTRO_BY_BOEGH,
  VICTORS_MADHUS,
  LA_BRAVA,
  KOKKEFROEEN,
  HERLIGHEDER,
  KROHN,
  FANDANKO,
  SPAR,
  NOERREGADES_KOEKKEN,
  MIN_KOBMAND,
  DEMO_SHOP,
  SAAKIN,
  DEMO_SLAGTER,
  STECHERS,
  GRENAA_SLAGTEHUS,
  ASAA_MOLLEHUS,
  STYLING_ONE,
  CLPARTYSERVICE,
  APETIT,
  GASTROLUX,
  HUMOER_MOEBLER,
  SKYTTEHUSET,
  FCKING_PIZZA,
  LANDSBYKOKKEN,
  DETROIT_PIZZA,
  CAMP_KAFFE,
  DININGSIX,
  KOKKERIET_SVENSSON,
}

export const storeTypeNames = [
  'catersys',
  'meny',
  'city-catering',
  'new-year',
  'gourmiddag',
  'gastro-by-boegh',
  'victors-madhus',
  'la-brava',
  'kokkefroeen',
  'herligheder',
  'krohn',
  'fandanko',
  'spar',
  'noerregades-koekken',
  'min-kobmand',
  'demo-shop',
  'saakin',
  'demo-slagter',
  'stechers',
  'grenaa-slagtehus',
  'asaa-mollehus',
  'styling-one',
  'clpartyservice',
  'apetit',
  'gastrolux',
  'humoer-moebler',
  'skyttehuset',
  'fcking-pizza',
  'landsbykokken',
  'detroit-pizza',
  'camp-kaffe',
  'diningsix',
  'kokkeriet-svensson',
];

export enum StoreRedirects {
  HERLIGHEDER = 'herligheder.dk',
  FANDANKO = 'fandanko.dk',
}

export enum StoreId {
  WIKA_MENY = 78,
  DINING_SIX_NYTAAR = 201,
  MENY_SALTUM = 33,
  MENY_VIBY = 81,
  MENY_FJERRITSLEV = 29,
  MENY_SVOGERSLEV = 84,
  MENY_AARUP = 62,
  MENY_BOGENSE = 64,
  MENY_THORSOE = 42,
  MENY_HADSUND = 117,
  MENY_PARKVEJ = 72,
}

export interface ContentResponse {
  content: string;
  defaultContent: string;
  merchant: Merchant;
}

export interface ParsedContentResponse {
  content: {
    Name: string;
    Children: ContentSection[];
  };
  defaultContent: {
    Name: string;
    Children: ContentSection[];
  };
  merchant: Merchant;
}

export interface Merchant {
  id: number;
  disabled: boolean;
  name: string;
  type: StoreType;
  storeName: string;
  mailingWorkspaceId: string;
  nxtTrackingLink: string;
  allowCardPayments: boolean;
  allowCashPayments: boolean;
  shortTimeDeliveryEnabled: boolean;
  woltVenueId: string;
  brand?: string;
  region?: string;
  subbrand?: string;
  address?: string;
  enableEAN: boolean;
  enableMembers: boolean;
  enablePriceGroups: boolean;
  enableReclaimAddress: boolean;
  enableMemberInvoice: boolean;
  enableNonMemberInvoice: boolean;
  enableDiscountCodes: boolean;
  enableCategoryCards: boolean;
  enableGoToBasketDialog: boolean;
  disableAddress: boolean;
  disableOrderNote: boolean;
  disableAlternativeAddress: boolean;
  enableWolt: boolean;
  cardPaymentText: string;
  cashPaymentText: string;
  invoicePaymentText: string;
  cashOnOrderPaymentText: string;
  cashOnPickupPaymentText: string;
  enableGiftCards: boolean;
  giftCardMonths: number;
  minimumGiftCardAmount: number;
  useAgeVerification: boolean;
  disableOpenShippingDialog: boolean;
  enableSearch: boolean;
  enableKiosk: boolean;
  useKioskShipping: boolean;
  kioskTurnOff: string;
  kioskTurnOn: string;
  showCompositeTopAddToCart: boolean;
  openingHours: string;
  cookieLastUpdate: string;
  isEventStore: boolean;
  smileyUrl: string;
}

export interface ContentSection {
  Name: string;
  Properties: ContentProperty[];
  Children: ContentSection[];
}

export interface ContentProperty {
  Name: string;
  Value: any;
}

export function PropertiesToMap(properties: ContentProperty[]): Record<string, any> {
  const map: Record<string, any> = {};
  properties.forEach((p) => {
    map[p.Name] = p.Value;
  });
  return map;
}

export type Content = Record<string, Map<string, any>>;

export interface ErrorMessages {
  pickCustomer?: string;
  somethingWentWrong: string;
  invalidLogin: string;
}

export interface Link {
  name: string;
  url: string;
  params?: Record<string, any>;
  button?: boolean;
}

export interface UmbracoLink {
  Name: string;
  Target: string;
  Url: string;
  Type: number;
}

export interface Image {
  src: string;
  alt: string;
}

export interface BreadCrumb {
  label: string;
  url: string;
}

export type MerchantContent = BurgerMenuContent | SubNavigationContent | PageContent | LinkContent | CategoryBurgerLink;

export interface ConfirmationAdvertisement {
  descriptionText: string;
  link: UmbracoLink;
  background: string;
  advertisementImage: string;
  iconImage: string;
  priority: number;
  productIds: string[];
}

export interface BurgerMenuContent {
  type: 'burger';
  title: string;
  pages: LinkContent[];
  showContentPage: boolean;
  link?: string;
  linkTarget?: string;
  hideOnMobile: boolean;
}

export interface SubNavigationContent {
  type: 'subNav';
  title: string;
  pages: LinkContent[];
  showContentPage: boolean;
  link?: string;
  linkTarget?: string;
}

export interface CategoryBurgerLink {
  type: 'categoryBurger';
  title: string;
  categoryId: number;
  hideOnMobile: boolean;

  link?: string;
  linkTarget?: string;
  pages?: LinkContent[];
  showContentPage?: boolean; // not set. There to match BurgerMenuContent
}

export interface PageContent {
  type: 'simple' | 'hidden';
  titleText: string;
  hideTitle?: boolean;
  contentText: string;
  mobileContentText: string;
  pageTitle: string;
  pageDescription: string;
  pageUrl: string;
}

export interface LinkContent {
  type: 'link';
  titleText: string;
  targetUrl: string;
  new: boolean;
}

export interface OnlineFolder {
  Children: ProductContent;
}

export interface ProductContent {
  Name: string;
  Properties: ContentProperty[];
}

export interface OnlineStrip {
  type: OnlineContentTypes.Strip;
  productIds: string[];
  categoryIds: string[];
  contentPageIds: string[];
  displayHome: boolean;
  stripTitleText: string;
  link: UmbracoLink;
  bodyText: string;
  mediaPosition: 'Left' | 'Right' | undefined;
  mediaContent: string;
  mediaWidth: number;
  backgroundColor: string;
  primaryColor: string;
  secondaryColor: string;
  buttonBgColor: string;
  buttonTextColor: string;
}

export interface OnlineStripInfoboxes {
  type: OnlineContentTypes.StripInfoboxes;
  productIds: string[];
  categoryIds: string[];
  contentPageIds: string[];
  displayHome: boolean;
  stripTitleText: string;
  infoboxes: { image: string; title: string; text: string; richText: string }[];
  columns: number;
  backgroundColor: string;
  primaryColor: string;
  secondaryColor: string;
}

export interface OnlineStripImage {
  type: OnlineContentTypes.StripImage;
  productIds: string[];
  categoryIds: string[];
  contentPageIds: string[];
  displayHome: boolean;
  mediaContent: string;
  leftPadding: number;
  rightPadding: number;
  topPadding: number;
  bottomPadding: number;
  backgroundColor: string;
}

export interface OnlineInfobox {
  type: OnlineContentTypes.Infobox;
  productIds: string[];
  infoboxes: { title: string; info: string }[];
}

export interface OnlineIconLine {
  type: OnlineContentTypes.IconLine;
  productIds: string[];
  title: string;
  lines: { icon: string; text: string }[];
}

export type OnlineContent = OnlineStrip | OnlineStripInfoboxes | OnlineInfobox | OnlineIconLine | OnlineStripImage;
export type OnlineStripContent = OnlineStrip | OnlineStripInfoboxes | OnlineStripImage;

export enum OnlineContentTypes {
  Strip = 0,
  Infobox,
  IconLine,
  StripInfoboxes,
  StripImage,
}

export interface Question {
  QuestionText: string;
  AnswerText: string;
}

export interface MediaContent {
  Media: string;
  Label: string;
}

export interface OnlineStripInfobox {
  Media: string;
  Title: string;
  Text: string;
  RichText: string;
}

export interface NewsletterSubscription {
  Id: number;
  UniqueKey: string;
  Name: string;
}

export interface NewsletterCustomer {
  name: string;
  email: string;
  mailList: number;
}

export interface Smiley {
  nameTrackingId: number;
  cvr: string;
  rating: SmileyState;
}

export enum SmileyState {
  None = 0,
  Happy = 1,
  Ok = 2,
  Warning = 3,
  Sad = 4,
}
